// import './chat/hermes';
import Vue, {
  App, vuetify, store, router, i18n,
} from '@/vue.init';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
